export const ROLE_TYPE = {
  ADMIN: 1,
  SUPER_ADMIN: 2,
  HR_ADMIN: 3, // PIS identity role only; never use as an effective behavior role.
  EMPLOYEE: 4
}
